import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 50px;

  @media screen and (max-width: 767px) {
    padding: 20px;
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 30%;
  margin-bottom: 30px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const Option = styled.div`
  font-family: Poppins-Regular;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: #626262;
  cursor: pointer;
  padding: 10px 10px;
  width: fit-content;
  flex-grow: 1;
  
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid ${props => props.active ? '#D40020' : '#BFBEBE'};

  &:hover {
    background: #ffe8eb;
  }
`;

export const OptionIcon = styled.img`
  height: 20px;
  margin-right: 15px;
`;

export const Form = styled.form`
  width: 30%;
  margin-top: 5px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

export const InputLabel = styled.span`
  font-family: Poppins-Bold;
  font-style: normal;
  font-size: 14px;
  line-height: 21px;
  color: #4F4F4F;
`;

export const InputText = styled.input`
  font-family: Poppins-Regular;
  font-size: 16px;
  line-height: 21px;
  color: #4F4F4F;
  border-radius: 2px;
  border: 1px solid #DEDDDC;
  box-sizing: border-box;
  padding: 6px 8px;
  width: 100%;

  ::placeholder {
    color: #BFBEBE;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: baseline;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const Price = styled.span`
  font-family: Poppins-Bold;
  color: #D40020;
  font-size: 24px;
  line-height: 21px;
`;

export const PriceLabel = styled.span`
  font-family: Poppins-Regular;
  color: #4F4F4F;
  font-size: 18px;
  line-height: 21px;
  margin-right: 5px;
`;

export const ErrorRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  @media screen and (max-width: 767px) {
    margin-top: 10px;
  }
`;

export const Error = styled.div`
  font-family: Poppins-Regular;
  font-style: 700;
  font-size: 14px;
  line-height: 21px;
  color: #D40020;
`;

export const ActionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;

  @media screen and (max-width: 767px) {
    margin-top: 20px;
  }
`;

export const BackBtn = styled.div`
  border: 2px solid #D40020;
  box-sizing: border-box;
  border-radius: 500px;
  color: #D40020;
  padding: 10px;
  width: 100%;
  cursor: pointer;
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  text-align: center;

  @media screen and (max-width: 767px) {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }

  &[disabled] {
    pointer-events: none;
    opacity: 0.8;
  }
`;

export const SubmitBtn = styled.button`
  background: #D40020;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  border-radius: 500px;
  padding: 10px;
  width: 100%;
  cursor: pointer;
  color: #fff;
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 0;
  // min-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: fit-content;

  &[disabled] {
    pointer-events: none;
    opacity: 0.8;
  }
`;